module.exports = __webpack_public_path__ + "media/new_message.5280fd34.wav";